import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
// Core
import { Grid, Box } from '@mui/material';
// Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Checkbox } from 'Components';
// Utilities
import {
  getFeatureDisplayCode,
  isParentEnabled,
  disableChildModules,
} from '../modules/hierarchicalFeatures';
//Styles
import './styles.scss';

const SubModules = (props) => {
  const { messages } = useIntl();

  //Props
  const {
    onShow,
    handleClose,
    module
  } = props;

  //State local
  const [sections, setSections] = useState();

  const initialValues = () => {
    let result;
    if (module) {
      result = {
        globalPermission: module,
        localPermissions: []
      }
      // groupnames availables
      const groupsNames = [
        'Contacts',
        'API',
        'Roles',
        'Tags',
        'Users',
        'Asset',
        'AssetSubtypes',
        'KeyFobs',
        'Temperature',
        'Crews',
        'Driver',
        'Fuelcards',
        'Inputs',
        'Locations',
        'Equipment',
        'VehicleStatus',
        'Services',
        'UnitSettings',
        'DriverStatus',
        'Behavior',
        'WorkOrdersCatalogs',
      ];
      let resultSubModules = module.subModules || [];
      resultSubModules = resultSubModules.filter(subModule =>
        !groupsNames.includes(subModule.groupName) ||
        subModule.name !== 'Edit' ||
        resultSubModules.some(item =>
          item.groupName === subModule.groupName &&
          item.name !== 'Edit'
        )
      );

      //Filtrar sub modulos por secciones
      const filterGroupName = resultSubModules.map(subModule => {
        return [subModule.groupName, subModule]
      });

      const sections = [...new Map(filterGroupName).values()];

      sections.forEach((section) => {
        result.localPermissions.push({
          groupName: section.groupName,
          subModules: resultSubModules.filter((subModule) => subModule.groupName === section.groupName)
        });
      });

      setSections(result);
    } else {
      setSections();
    }
  }

  const closeModal = () => {
    if (sections) {
      let moduleResult = {
        ...sections.globalPermission,
        subModules: []
      }
      sections.localPermissions.forEach((item) => {
        item.subModules.forEach(subModule => {
          moduleResult.subModules.push(subModule)
        });
      })
      handleClose(moduleResult);
    } else {
      handleClose(module);
    }
  }

  useEffect(() => {
    if (module) {
      initialValues();
    }
  }, [module])

  return (
    <Modal
      title={messages[`role_${module?.code}`] || module?.name}
      open={onShow}
      size="small"
      handleClose={() => closeModal()}
      position="right"
    >
      <ModalBody className={'modalBodyComplete'}>
        <div style={{ padding: 24, paddingBottom: 40 }}>
          {
            sections &&
            <Grid
              container
              justifyContent={'center'}
              direction={'column'}
              className="paddingBody"
              spacing={2}
            >
              <Grid item sm={12}>
                <label className="title-permission">{messages['role_globalAccess']}</label>
                <Grid key={`global-permissions`} item sm={12}>
                  {
                    sections.globalPermission.userCode !== 0 ? // Module Map
                      <Checkbox
                        value={sections.globalPermission.checked}
                        onChange={(checked) => {
                          let result = sections;
                          let globalPermission = sections.globalPermission;
                          globalPermission.checked = checked;

                          result = {
                            ...result,
                            globalPermission
                          }

                          if (sections.localPermissions.length) {
                            let localPermissions = sections.localPermissions;
                            localPermissions.forEach((item) => {
                              item.subModules.forEach((subModule) => {
                                if (checked) {
                                  // When enabling: only auto-check truly independent features (no :: at all)
                                  // Features with ::parent or ::! should stay unchecked
                                  const hasHierarchy = subModule.code.includes('::');
                                  subModule.checked = !hasHierarchy;
                                } else {
                                  // When disabling: uncheck all subModules
                                  subModule.checked = false;
                                }
                              })
                            });

                            result = {
                              ...result,
                              localPermissions
                            }
                          }

                          setSections(result);
                        }}
                        size="small"
                        id={`permission-${sections.globalPermission.code}`}
                        label={messages[`role_${sections.globalPermission.code}`]}
                      /> :
                      <Box mt={1} mb={1}><label>{messages[`role_${sections.globalPermission.code}`]}</label></Box>
                  }
                </Grid>
              </Grid>
              {sections.localPermissions.length ?
                <Grid item sm={12}>
                  <label className="title-permission">{messages['role_localAccess']}</label>
                  {sections.localPermissions.map((item, indexSection) =>  
                  
                     <Grid key={`section-local-permissions-${indexSection}`} item sm={12}>
                      <Grid item sm={12}>
                        <Box mt={2} mb={1}>
                          <label>{messages[`role_${item.groupName}`] ?? item.groupName}</label>
                        </Box>
                      </Grid>
                      {item.subModules.map((subModule, indexSubModule) => {
                        // Get flat list of all subModules for hierarchical checks
                        const allSubModules = sections.localPermissions.flatMap(lp => lp.subModules);
                        const parentEnabled = isParentEnabled(subModule, allSubModules);
                        const isDisabled = !sections.globalPermission?.checked || !parentEnabled;

                        return (
                         <Grid key={`local-permissions-${indexSubModule}`} item sm={12}>
                          <Checkbox
                            key={`local-permissions-${indexSubModule}`}
                            value={subModule.checked}
                            onChange={(checked) => {
                              // Create deep copy to ensure React detects the state change
                              const newLocalPermissions = sections.localPermissions.map((section, sIdx) => ({
                                ...section,
                                subModules: section.subModules.map((sm, smIdx) => {
                                  if (sIdx === indexSection && smIdx === indexSubModule) {
                                    return { ...sm, checked };
                                  }
                                  return { ...sm };
                                })
                              }));

                              // If unchecking, also disable any child subModules that depend on this one
                              if (!checked) {
                                const allSubModules = newLocalPermissions.flatMap(lp => lp.subModules);
                                disableChildModules(subModule, allSubModules);
                              }

                              setSections({
                                ...sections,
                                localPermissions: newLocalPermissions
                              });
                            }}
                            size="small"
                            id={`permission-${subModule.code}`}
                            label={messages[`role_${sections.globalPermission.code}_${subModule.name === 'Tags'? subModule.name : getFeatureDisplayCode(subModule.code)}`] || subModule.name}
                            disabled={isDisabled}
                          />
                        </Grid>
                      )})}
                    </Grid>
                  )}
                </Grid>
                : ''}
            </Grid>
          }
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => closeModal()}
          className="btn-cancel"
        >
          {messages["permissions_back"]}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SubModules;